import React from 'react';
import { Edit, FileText, File } from 'lucide-react';
import Button from '../../../components/ui/Button';

const UploadedDocumentsCard = ({ documentsData, onEdit }) => {
  const getFileIcon = (type) => {
    switch (type) {
      case 'pdf':
        return <FileText className="h-5 w-5 text-red-500" />;
      case 'xls': case'xlsx':
        return <File className="h-5 w-5 text-green-500" />;
      default:
        return <File className="h-5 w-5 text-gray-500" />;
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      {/* Card Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-gray-900">
          Uploaded Documents
        </h2>
        <Button
          onClick={onEdit}
          variant="ghost"
          size="sm"
          className="text-gray-500 hover:text-gray-700 p-2"
        >
          <Edit className="h-4 w-4" />
        </Button>
      </div>

      {/* Documents List */}
      <div className="space-y-4">
        {documentsData?.map((document) => (
          <div 
            key={document?.id}
            className="flex items-center space-x-3 p-3 rounded-lg border border-gray-100 bg-gray-50"
          >
            {/* File Icon */}
            <div className="flex-shrink-0">
              {getFileIcon(document?.type)}
            </div>

            {/* Document Info */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2">
                <p className="text-sm font-medium text-gray-900">
                  {document?.label}
                </p>
              </div>
              <p className="text-sm text-gray-600 truncate">
                {document?.fileName}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UploadedDocumentsCard;